<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />
    <herbicide-statistics />
  </b-container>
</template>
<script>

import { core } from '@/config/pluginInit'
import HerbicideStatistics from '@/components/dashboard/HerbicideStatistics.vue'

export default {
  name: 'ManagerGraphHerbicides',
  middleware: ['auth', 'manager'],
  components: {
    HerbicideStatistics

  },
  metaInfo () {
    return {
      title: 'Herbicides Graph'
    }
  },

  mounted () {
    core.index()
  }

}
</script>
